module.exports = __webpack_public_path__ + "img/icon22.d4d8cbf5.png";